import { render, staticRenderFns } from "./form-mail.vue?vue&type=template&id=36c4f9da&scoped=true"
import script from "./form-mail.vue?vue&type=script&lang=js"
export * from "./form-mail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c4f9da",
  null
  
)

export default component.exports